module.exports = __webpack_public_path__ + "img/mall06.83d66435.png";